export default __webpack_public_path__ + "static/media/robots.deda1e05.PNG";